let wishlistCount = document.querySelectorAll(".wishlist-count");
let wishlistPageWrapper = document.querySelector(".wishlist_page_wrapper");
let wishlistContainer = document.querySelector(".wishlist_container");
let wishlistHeader = document.querySelector(".wishlist_header");

async function waitForCustomerId() {
  return new Promise((resolve) => {
    let checkInterval = setInterval(() => {
      if (typeof SWGetCustomerWishlistId === "function") {
        let customerId = SWGetCustomerWishlistId();
        if (customerId && customerId !== 0) {
          clearInterval(checkInterval);
          resolve(customerId);
        }
      }
    }, 100);
  });
}

async function fetchWishlist() {
  if (!wishlistContainer) {
    return;
  }

  let customerId = await waitForCustomerId();

  wishlistContainer.innerHTML = "<div class='loading_text'>Loading...</div>";
  wishlistContainer.style.display = "block";
  wishlistContainer.style.textAlign = "center";

  try {
    const response = await fetch(
      `/a/wishlist?type=api&customerid=${customerId}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    // Check for API error
    if (data.type === 'error') {
      console.error('API Error:', data.message);
      wishlistContainer.innerHTML = `
        <div class='error_text'>
          <h3>Unable to load wishlist</h3>
          <p>${data.message}</p>
          <p>Please try again later or contact support.</p>
        </div>
      `;
      return;
    }

    // Update count
    wishlistCount.forEach((item) => {
      item.textContent = data.count;
    });

    // Clear existing wishlist content
    wishlistContainer.innerHTML = "";

    // If wishlist empty
    if (data.count === 0) {
      if (wishlistHeader) {
        wishlistHeader.style.display = "none";
      }
      wishlistContainer.innerHTML =
        "<div class='empty_text'>Your Wishlist is Empty</div>";
      wishlistContainer.style.display = "block";
      return;
    }

    // Check if items array exists
    if (!data.items || data.items.length === 0) {
      console.log('No items array in response');
      wishlistContainer.innerHTML = "<div class='empty_text'>Your Wishlist is Empty</div>";
      return;
    }

    data.items.forEach((item) => {
      console.log('Rendering item:', item.title, item.featured_image, item.price);
      
      const wishlistItem = `
          <a href="/products/${item.handle}" class="wishlist_card">
            <div class="wishlist_image">
              <img src="${item.featured_image}" alt="${item.title}" width="200" height="200">
            </div>
            <div class="content grid-product__meta">
              <div class="grid-product__title">${item.title}</div>
              <div class="grid-product__price">Rs.${item.price}</div>
            </div>
          </a>
        `;

      wishlistContainer.innerHTML += wishlistItem;
    });

    wishlistContainer.style.display = "grid";
    console.log('Finished rendering. Container HTML:', wishlistContainer.innerHTML);

  } catch (error) {
    console.error("Error fetching wishlist:", error);
    if (wishlistContainer) {
      wishlistContainer.innerHTML =
        "<div class='error_text'>Failed to load wishlist. Please try again later.</div>";
    }
  }
}

fetchWishlist();
document.addEventListener("wishlist:updated", fetchWishlist);